module.exports = __webpack_public_path__ + "static/media/am.7e1538f6.svg";